import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedCloudWatchApp from "./EmbeddedCloudWatchApp";
const CloudWatchApp = () => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("aws_cloudwatch_app.title") }, /* @__PURE__ */ React.createElement("span", null, t("aws_cloudwatch_app.description"))), /* @__PURE__ */ React.createElement(EmbeddedCloudWatchApp, null));
};
export default CloudWatchApp;
